import _ from 'lodash';
import imagesLoaded from 'imagesLoaded';
import Siema from 'siema';

const handleOnClick = ( e, viewport ) => {
	let image = e.target.getAttribute('data-viewport');
	if (image) viewport.getElementsByTagName('img')[0].setAttribute('src', image);
}


const paginate = ( thumbnails, siema ) => {
	let next = thumbnails.querySelector('.gallery__thumbnails__next');
	let prev = thumbnails.querySelector('.gallery__thumbnails__prev');
	if ( prev ) prev.onclick = () => siema.prev(1);
	if ( next ) next.onclick = () => siema.next(1);
}

const initializeThumbnails = (viewport, thumbnails) => {
	const mySiema = new Siema({
		selector: thumbnails.querySelector('.gallery__thumbnails__images'),
		duration: 200,
		easing: 'ease-out',
		perPage: {
			0: 3,
			530: 4,
			700: 5
		},
		startIndex: 0,
		draggable: true,
		threshold: 20,
		loop: false,
		onInit: () => thumbnails.onclick = (e) => handleOnClick(e, viewport)
	});
//	imagesLoaded(thumbnails, () => mySiema.init());
	paginate(thumbnails, mySiema);
	document.querySelector('#modal-listings').addEventListener('click', (e) => {
		let wrapper = document.querySelector('#modal-listings .modal__wrapper');
		let button = document.querySelector('#modal-listings .modal__nav__close');
		if (e.target === wrapper) mySiema.destroy(true);
		if (e.target === button) mySiema.destroy(true);
	})
}

const mount = (id, viewport, thumbnails ) => {
	if ( thumbnails && thumbnails.style.display === 'none' ) {
		viewport.style.display = 'block';
		thumbnails.style.display = 'block';
	}
	initializeThumbnails(viewport, thumbnails);
}

const initialize = ( id ) => {
	let viewport = document.querySelector( '#modal-' + id + ' .gallery__viewport' );
	let thumbnails = document.querySelector( '#modal-' + id + ' .gallery__thumbnails' );
	mount(id, viewport, thumbnails);
}

export default function ( id ) {
	_.delay( () => {
		initialize( id );
	}, 1000);
}
